import { render, staticRenderFns } from "./SaleOrderBalanceView.vue?vue&type=template&id=b3f6b7f0&scoped=true"
import script from "./SaleOrderBalanceView.vue?vue&type=script&lang=js"
export * from "./SaleOrderBalanceView.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderBalanceView.vue?vue&type=style&index=0&id=b3f6b7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f6b7f0",
  null
  
)

export default component.exports